import { JsonLd } from "./JsonLd";

const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "PalletRackingUSA",
  url: "https://palletrackingusa.com",
  logo: "https://palletrackingusa.com/og-image.png",
  description:
    "Nationwide industrial brokerage connecting warehouse managers with quality pallet racking systems — new and used — from vetted manufacturers across North America.",
  telephone: "1-888-315-7225",
  email: "info@palletrackingusa.com",
  sameAs: [],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "1-888-315-7225",
    contactType: "sales",
    availableLanguage: ["English"],
    areaServed: ["US", "CA"],
  },
};

const LOCAL_BUSINESSES = [
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://palletrackingusa.com/#utah",
    name: "PalletRackingUSA — Utah",
    url: "https://palletrackingusa.com/locations/utah",
    telephone: "1-888-315-7225",
    email: "utah@palletrackingusa.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Salt Lake City",
      addressRegion: "UT",
      postalCode: "84104",
      addressCountry: "US",
    },
    parentOrganization: { "@id": "https://palletrackingusa.com" },
    openingHours: "Mo-Fr 07:00-18:00",
    areaServed: "Western United States",
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://palletrackingusa.com/#north-carolina",
    name: "PalletRackingUSA — North Carolina",
    url: "https://palletrackingusa.com/locations/north-carolina",
    telephone: "1-888-315-7225",
    email: "greensboro@palletrackingusa.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Greensboro",
      addressRegion: "NC",
      addressCountry: "US",
    },
    parentOrganization: { "@id": "https://palletrackingusa.com" },
    openingHours: "Mo-Fr 07:00-18:00",
    areaServed: "Eastern United States",
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://palletrackingusa.com/#ontario",
    name: "PalletRackingUSA — Ontario",
    url: "https://palletrackingusa.com/locations/ontario",
    telephone: "1-888-315-7225",
    email: "ontario@palletrackingusa.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Toronto",
      addressRegion: "ON",
      addressCountry: "CA",
    },
    parentOrganization: { "@id": "https://palletrackingusa.com" },
    openingHours: "Mo-Fr 07:00-18:00",
    areaServed: "Canada",
  },
];

export function OrganizationSchema() {
  return (
    <>
      <JsonLd data={ORG_SCHEMA} />
      {LOCAL_BUSINESSES.map((biz) => (
        <JsonLd key={biz["@id"]} data={biz} />
      ))}
    </>
  );
}
